import { render, staticRenderFns } from "./Contactus.vue?vue&type=template&id=39c971e8&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"
import style0 from "./Contactus.vue?vue&type=style&index=0&id=39c971e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c971e8",
  null
  
)

export default component.exports